import React from "react";
import { render } from "react-dom";
import registry from "dynamic-module-registry";
import { getStore } from "../../shared_modules/common/store";
import BorrowerRegistrationClient from "./BorrowerRegistrationClient";
const initialState = registry.get("initialState");
const configState = registry.get("configState");

const props = {
  config: configState.config,
  store: getStore(initialState, () => configState.config),
};
const isFiveChatEnabled = initialState?.chatFive9Context?.isFiveChatEnabled;

render(
  <BorrowerRegistrationClient {...props} />,
  document.getElementById("pf-loan-funnel-registration"),
  document.addEventListener("DOMContentLoaded", function () {
    if (isFiveChatEnabled) return;
    require("../../shared_modules/livechat");
  }),
);

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/pages/borrower-registration/styles/borrower-registration.scss');